import React, { useEffect, useState } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
  Container,
  FormGroup,
  Input,
} from "reactstrap";
import InputPDF from "components/Input/InputPDF";

// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";
import { EnviaProtocoloDocumentoGerador } from "../../services/protocolo_gerador_service.js";
import { EnviaRequerimentoDocumentoGerador } from "../../services/protocolo_gerador_service.js";
import { EnviaProtocoloDocumentoTransportador } from "../../services/protocolo_transportador_service.js";
import { EnviaRequerimentoDocumentoTransportador } from "../../services/protocolo_transportador_service.js";
import { EnviaProtocoloDocumentoDestino } from "../../services/protocolo_destino_service.js";
import { EnviaRequerimentoDocumentoDestino } from "../../services/protocolo_destino_service.js";
import { api_PUT } from "../../services/api_service.js";

//Context
import { useAuth } from "../../context/auth.js";

export default function Documentos({
  item,
  opcao,
  handleProximoStep,
  handleStepAnterior,
}) {
  const { session, setLoading } = useAuth();

  const [registro, set_registro] = useState(null);

  const [documentos, set_documentos] = useState([]);

  const [observacoesRequerente, setObservacoesRequerente] = useState("");

  const [options_documentos, set_options_documentos] = useState([]);
  const loadOptionsDocumentos = () => {
    if (
      (session == null || (session && session.tipoAcesso === "Protocolo")) &&
      item
    )
      setObservacoesRequerente(item.observacaoRequerente ?? "");

    let acao = "";
    if (opcao.tipoCadastro === "Protocolo")
      acao = item.setupSolicitacaoAcaoNovoCadastro;
    else acao = item.setupSolicitacaoAcao;

    api_GET(
      `SetupSolicitacao/GetDocumentosByAcaoId/${acao.setupSolicitacaoAcao_Id}`
    )
      .then((result) => {
        set_options_documentos(result.data);

        if (opcao.tipoCadastro === "Protocolo") loadItemProtocolo();
        else if (opcao.tipoCadastro === "Requerimento") loadItemRequerimento();
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const loadItemProtocolo = () => {
    set_registro(item);
    if (item != null && item.protocoloDocumentos != null) {
      set_documentos(item.protocoloDocumentos);
    }
  };

  const loadItemRequerimento = () => {
    set_registro(item);
    if (item != null && item.requerimentoDocumento != null) {
      set_documentos(item.requerimentoDocumento);
    }
  };

  useEffect(() => {
    loadOptionsDocumentos();
  }, []);

  const confirmaAddFile = (lista_documento) => {
    let newDocumentos = [];
    documentos.map((m) => {
      if (m.documento_Id !== lista_documento.documento_Id)
        newDocumentos.push(m);
    });
    newDocumentos.push(lista_documento);
    set_documentos(newDocumentos);
  };

  const handleFile = (file, callback) => {
    if (file == null) {
      return;
    }

    setLoading(true);

    if (opcao.tipoCadastro === "Protocolo") {
      let json = carregaJsonProtocolo(file);
      if (
        opcao.segmento === "Grande Gerador" ||
        opcao.segmento === "Grande Gerador - PGRCC"
      )
        EnviaProtocoloDocumentoGerador(json, function (result) {
          setLoading(false);
          callback();
          confirmaAddFile(result.data);
        });
      else if (opcao.segmento === "Transportador")
        EnviaProtocoloDocumentoTransportador(json, function (result) {
          setLoading(false);
          callback();
          confirmaAddFile(result.data);
        });
      else if (opcao.segmento === "Destino Final")
        EnviaProtocoloDocumentoDestino(json, function (result) {
          setLoading(false);
          callback();
          confirmaAddFile(result.data);
        });
    } else if (opcao.tipoCadastro === "Requerimento") {
      let json = carregaJsonRequerimento(file);
      if (
        opcao.segmento === "Grande Gerador" ||
        opcao.segmento === "Grande Gerador - PGRCC"
      )
        EnviaRequerimentoDocumentoGerador(json, function (result) {
          setLoading(false);
          if (result.data.statusAnalise === "Reprovado") {
            let motivoReprovaAnalise = (result.data.motivoReprovaAnalise || "");
            if (motivoReprovaAnalise.trim() != "") {
              motivoReprovaAnalise += ". ";
            }
            showMessage(
              "Aviso",
              "ATENÇÃO: Os dados preenchidos nos campos " + motivoReprovaAnalise + " divergem do que consta no documento anexado. Favor inserir um novo documento ou retornar aos campos do requerimento correspondentes às informações divergentes e preenchê-los conforme o que consta em seu documento. Após realizar as correções, favor reanexar seu documento para nova validação. Caso opte por prosseguir com o documento inconsistente, seu requerimento será submetido à análise manual da SP Regula.",
              "warning",
              null
            );
          }
          callback();
          confirmaAddFile(result.data);
        });
      else if (opcao.segmento === "Transportador")
        EnviaRequerimentoDocumentoTransportador(json, function (result) {
          setLoading(false);
          if (result.data.statusAnalise === "Reprovado") {
            let motivoReprovaAnalise = (result.data.motivoReprovaAnalise || "");
            if (motivoReprovaAnalise.trim() != "") {
              motivoReprovaAnalise += ". ";
            }
            showMessage(
              "Aviso",
              "ATENÇÃO: Os dados preenchidos nos campos " + motivoReprovaAnalise + " divergem do que consta no documento anexado. Favor inserir um novo documento ou retornar aos campos do requerimento correspondentes às informações divergentes e preenchê-los conforme o que consta em seu documento. Após realizar as correções, favor reanexar seu documento para nova validação. Caso opte por prosseguir com o documento inconsistente, seu requerimento será submetido à análise manual da SP Regula.",
              "warning",
              null
            );
          }
          callback();
          confirmaAddFile(result.data);
        });
      else if (opcao.segmento === "Destino Final")
        EnviaRequerimentoDocumentoDestino(json, function (result) {
          setLoading(false);
          if (result.data.statusAnalise === "Reprovado") {
            let motivoReprovaAnalise = (result.data.motivoReprovaAnalise || "");
            if (motivoReprovaAnalise.trim() != "") {
              motivoReprovaAnalise += ". ";
            }
            showMessage(
              "Aviso",
              "ATENÇÃO: Os dados preenchidos nos campos " + motivoReprovaAnalise + " divergem do que consta no documento anexado. Favor inserir um novo documento ou retornar aos campos do requerimento correspondentes às informações divergentes e preenchê-los conforme o que consta em seu documento. Após realizar as correções, favor reanexar seu documento para nova validação. Caso opte por prosseguir com o documento inconsistente, seu requerimento será submetido à análise manual da SP Regula.",
              "warning",
              null
            );
          }
          callback();
          confirmaAddFile(result.data);
        });
    }
  };

  const carregaJsonProtocolo = (file) => {
    let json_submit = {
      protocoloDocumento_Id: 0,
      protocolo_Id: item.protocolo_Id,
      arquivo: file.name,
      arquivoBase64: file.base64,
      documento_Id: file.documento_Id,
      usuarioUltimaAlteracao_Id:
        session != null && session.tipoAcesso === "AreaRestrita"
          ? session.usuario_Id
          : null,
    };
    return json_submit;
  };

  const carregaJsonRequerimento = (file) => {
    let json_submit = {
      requerimentoDocumento_Id: 0,
      requerimento_Id: item.requerimento_Id,
      arquivo: file.name,
      arquivoBase64: file.base64,
      documento_Id: file.documento_Id,
      usuarioUltimaAlteracao_Id:
        session != null && session.tipoAcesso === "AreaRestrita"
          ? session.usuario_Id
          : null,
    };
    return json_submit;
  };

  const handleSubmitObservacoesRequerente = () => {
    setLoading(true);
    api_PUT("requerimento/ObservacoesRequerente", {
      requerimento_Id: item?.requerimento_Id,
      observacaoRequerente: observacoesRequerente,
    })
      .then((result) => {
        let _registro = { ...registro };
        _registro.observacaoRequerente = result.data;
        handleProximoStep(_registro);
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleConcluir = () => {
    if (
      (session == null || (session && session.tipoAcesso === "Protocolo")) &&
      options_documentos.filter(
        (x) =>
          documentos.filter((y) => y.documento_Id === x.documento_Id).length ===
          0
      ).length > 0
    ) {
      showMessage(
        "Aviso",
        "Você deve importar todos os documentos!",
        "error",
        null
      );
      return;
    }

    if (session == null || (session && session.tipoAcesso === "Protocolo"))
      handleSubmitObservacoesRequerente();
    else handleProximoStep(registro);
  };

  return (
    <>
      <div>
        <Card className={`card card-stats`}>
          <CardBody>
            <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
              <h2 className="titulo-solicitacao">Documentos Obrigatórios</h2>
              <h5 style={{ textAlign: "center" }}>
                * Os documentos devem ser enviados no formato PDF.
              </h5>
              <h5 style={{ textAlign: "center" }}>
                * Restam importar{" "}
                {
                  options_documentos.filter(
                    (x) =>
                      documentos.filter(
                        (y) => y.documento_Id === x.documento_Id
                      ).length === 0
                  ).length
                }{" "}
                de {options_documentos.length} documentos.
              </h5>
              <div className="formPrincipal">
                {options_documentos.length > 0 &&
                  options_documentos.map((m, key) => (
                    <Row
                      style={{
                        borderBottom: "1px solid rgba(0, 0, 0, .5)",
                        paddingBottom: "10px",
                        paddingTop: "10px",
                      }}
                    >
                      <Col md="3" lg="3" className="text-center" key={key}>
                        <b>
                          <p>{m.documento.descricao}</p>
                        </b>
                        <InputPDF
                          height="4rem"
                          width="4rem"
                          name={m.documento.descricao}
                          image={
                            documentos.filter(
                              (f) => f.documento_Id === m.documento.documento_Id
                            ).length > 0
                              ? {
                                name: documentos.filter(
                                  (f) =>
                                    f.documento_Id ===
                                    m.documento.documento_Id
                                )[0].arquivo,
                              }
                              : null
                          }
                          documento_id={m.documento_Id}
                          handlefile={handleFile}
                        ></InputPDF>
                      </Col>
                      <Col md="9">
                        <span>{m.documento.orientacao}</span>
                        {documentos.filter(
                          (f) =>
                            f.documento_Id === m.documento.documento_Id &&
                            f.statusAnalise === "Reprovado"
                        ).length > 0 && (
                          <div className="mt-2">
                            <b className="text-danger">Motivo Inconsistência: </b>
                            <span className="text-danger">
                              {
                                documentos.filter(
                                  (f) =>
                                    f.documento_Id === m.documento.documento_Id
                                )[0].motivoReprovaAnalise
                              }
                            </span>
                          </div>
                        )}
                      </Col>
                    </Row>
                  ))}

                {!session && (
                  <Row className="mt-3">
                    <Col md="12">
                      <FormGroup>
                        <b>
                          <label>Inclua aqui suas observações</label>
                        </b>
                        <Input
                          type="textarea"
                          name="observacaoRequerente"
                          onChange={(e) =>
                            setObservacoesRequerente(e.target.value)
                          }
                          value={observacoesRequerente}
                          maxLength="8000"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                )}
              </div>

              <Row>
                <Col lg="6" className="text-left">
                  <Button
                    color="secundary"
                    onClick={() => handleStepAnterior(registro)}
                    className="btn-mobile"
                    type="submit"
                  >
                    <i className="fas fa-chevron-left"></i> Voltar
                  </Button>
                </Col>
                {handleProximoStep != null && (
                  <Col lg="6" className="text-right">
                    <Button
                      color="success"
                      onClick={handleConcluir}
                      className="btn-mobile"
                      type="button"
                    >
                      <i className="fas fa-check"></i> Concluir
                    </Button>
                  </Col>
                )}
              </Row>
            </Container>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
